@if (model$ | async; as model) {
  <cx-view
    class="card"
    i18nRoot="orgUnit.details"
    >
    <div class="header">
      <div class="title-bar">
        <div class="title">
          <h3>
            {{ "units.details" | cxTranslate }}
          </h3>
        </div>
        <div class="actions">
          <a
            class="link edit"
            [class.disabled]="(isInEditMode$ | async)"
            [routerLink]="{ cxRoute: 'orgUnitEdit', params: model } | cxUrl"
            >
            {{ "units.buttons.edit" | cxTranslate }}
          </a>
        </div>
      </div>
      <a class="link close" routerLink="../">
        <cx-icon type="CLOSE" class="cx-icon fas fa-times"></cx-icon>
      </a>
    </div>
    <div class="main">
      <section main class="details">
        <div class="property">
          <label>{{ "orgUnit.name" | cxTranslate }}</label>
          <span class="value">
            {{ model.name }}
          </span>
        </div>
        <div class="property">
          <label>{{ "orgUnit.uid" | cxTranslate }}</label>
          <span class="value">
            {{ model.uid }}
          </span>
        </div>
        <div class="property">
          <label>{{ "orgUnit.active" | cxTranslate }}</label>
          <span class="value" [class.is-active]="model.active">
            {{
            (model.active ? "units.enabled" : "units.disabled")
            | cxTranslate
            }}
          </span>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th>{{ "units.days" | cxTranslate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {{ "units.configEKPriceChangeDays" | cxTranslate }}
              </td>
              <td class="config-days">
                {{ model.configEKPriceChangeDays }}
              </td>
            </tr>
            <tr>
              <td>
                {{ "units.configProductCreationDays" | cxTranslate }}
              </td>
              <td class="config-days">
                {{ model.configProductCreationDays }}
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      @if (model.distributionAgreements) {
        <section main class="details">
          <div class="distributionAgreementProperty">
            <label>{{ "orgUnit.distributionAgreements" | cxTranslate }}</label>
            <span class="value">
              @for (distributionAgreement of model.distributionAgreements; track distributionAgreement) {
                <div class="distributionAgreementValue">
                  {{distributionAgreement.code}}&emsp;{{distributionAgreement.name}}
                </div>
              }
            </span>
          </div>
        </section>
      }
    </div>
  </cx-view>
}

<router-outlet></router-outlet>
